import { setSvgIconSize } from 'LuxKit/SvgIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import { tierDarkContrastColorStyle, tierDarkSecondaryBackgroundStyle } from 'styles/utils/tierStyles'

const LoyaltyBenefitIconContainer = styled.div`
  flex-shrink: 0;
  display: grid;
  place-items: center;
  height: ${rem(20)};
  width: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.round};
  ${setSvgIconSize(15)}
  ${tierDarkSecondaryBackgroundStyle}
  ${tierDarkContrastColorStyle}

  ${mediaQueryUp.tablet} {
    height: ${rem(24)};
    width: ${rem(24)};
  }
`

export default LoyaltyBenefitIconContainer
